import { ObjectId } from 'bson';

export class MongoUtils {
    static generateObjectId(): string {
        return new ObjectId().toHexString();
    }
}
